const state = () => ({
  selectedMemberIds: [],
})

const getters = {
}

const mutations = {
  setSelectedMemberIds(state, selectedMemberIds) {
    state.selectedMemberIds = selectedMemberIds
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}